export const getAvatarInitials = (teamName: string) =>
    teamName
        .replaceAll(' ', '')
        .substring(0, 2)
        .toUpperCase();
